module.exports = __webpack_public_path__ + "img/SES_Megaliner_Profiles.922d6d38.jpg";